import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Permission } from '../models/permission.model';
import { PermissionMode } from '../enums/permission-mode';
import { OrderStage } from '../enums/order-stage';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  constructor(private http: HttpClient) {}

  getPermissions(): Observable<Permission[]> {
    return this.http.get<Permission[]>('orderdynamicpermissions');
  }

  getOnePermission(id: string): Observable<Permission> {
    return this.http.get<Permission>(`orderdynamicpermissions/${id}`);
  }

  createPermission(data: Partial<Permission>): Observable<Permission> {
    return this.http.post<Permission>('orderdynamicpermissions', data);
  }

  updatePermission(
    id: string,
    data: { mode: PermissionMode }
  ): Observable<string> {
    return this.http.put<string>(`orderdynamicpermissions/${id}`, data, {
      responseType: 'text' as 'json',
    });
  }

  deletePermission(id: string): Observable<string> {
    return this.http.delete<string>(`orderdynamicpermissions/${id}`, {
      responseType: 'text' as 'json',
    });
  }
}
